export default {
  title: 'ติดตามหนี้',
  subtitle: 'จัดการใบแจ้งหนี้ค้างชำระและการยกระดับ',
  pipeline: {
    title: 'ไปป์ไลน์',
    notice_1: 'หนังสือแจ้งครั้งที่ 1',
    notice_2: 'หนังสือแจ้งครั้งที่ 2',
    final_notice: 'หนังสือแจ้งครั้งสุดท้าย',
    legal: 'กฎหมาย',
    resolved: 'แก้ไขแล้ว',
    notice_1_sub: 'ค้างชำระ 30+ วัน',
    notice_2_sub: 'ค้างชำระ 60+ วัน',
    final_notice_sub: 'ค้างชำระ 90+ วัน',
    legal_sub: 'ยกระดับโดยผู้ดูแล',
  },
  fields: {
    invoice: 'ใบแจ้งหนี้',
    customer: 'ลูกค้า',
    unit: 'ห้อง',
    property: 'อาคาร',
    amount_due: 'ยอดค้างชำระ',
    days_overdue: 'วันที่เกินกำหนด',
    stage: 'ขั้นตอน',
    created_at: 'เปิดเคส',
    escalated_at: 'ยกระดับล่าสุด',
    notice_sent_at: 'ส่งหนังสือแจ้ง',
    resolved_at: 'แก้ไขแล้ว',
  },
  stages: {
    notice_1: 'หนังสือแจ้งครั้งที่ 1',
    notice_2: 'หนังสือแจ้งครั้งที่ 2',
    final_notice: 'หนังสือแจ้งครั้งสุดท้าย',
    legal: 'กฎหมาย',
    resolved: 'แก้ไขแล้ว',
  },
  detail: {
    page_title: 'เคส {{invoice_number}}',
    unit_label: 'ห้อง {{unit}}',
  },
  actions: {
    escalate: 'ยกระดับ',
    resolve: 'แก้ไขแล้ว',
    add_note: 'เพิ่มบันทึก',
    mark_notice_sent: 'บันทึกการส่งหนังสือแจ้งวันนี้',
    generate_legal_notice: 'สร้างหนังสือทางกฎหมาย',
    view_invoice: 'ดูใบแจ้งหนี้',
  },
  escalate_modal: {
    title: 'ยกระดับเคส',
    current_stage: 'ขั้นตอนปัจจุบัน',
    target_stage: 'ยกระดับไปที่',
    confirm: 'ยกระดับ',
    to_legal: 'ยกระดับสู่กระบวนการทางกฎหมาย',
    to_resolved: 'ทำเครื่องหมายว่าแก้ไขแล้ว',
  },
  resolve_confirm: 'ทำเครื่องหมายเคสนี้ว่าแก้ไขแล้ว? ใบแจ้งหนี้ยังค้างชำระจนกว่าจะบันทึกการชำระเงิน',
  notes: {
    title: 'บันทึก',
    placeholder: 'เพิ่มบันทึก...',
    added_by: 'โดย {{user}}',
    notice_sent_log: 'อัปเดตวันที่ส่งหนังสือแจ้งแล้ว',
    empty: 'ยังไม่มีบันทึก',
  },
  timeline: {
    title: 'ไทม์ไลน์การยกระดับ',
    case_created: 'เปิดเคสแล้ว',
    auto_escalated: 'ยกระดับอัตโนมัติเป็น {{stage}}',
    manually_escalated: 'ยกระดับโดยผู้ดูแลเป็น {{stage}}',
    resolved: 'ปิดเคสแล้ว',
    upcoming: 'ถัดไป: {{stage}} อัตโนมัติวันที่ {{date}}',
  },
  empty: {
    title: 'ไม่มีเคสค้างชำระ',
    description: 'เคสจะถูกสร้างอัตโนมัติเมื่อใบแจ้งหนี้ค้างชำระเกิน 30 วัน',
  },
  errors: {
    cannot_escalate_resolved: 'ไม่สามารถยกระดับเคสที่แก้ไขแล้ว',
    cannot_move_backward: 'เคสสามารถเลื่อนขั้นตอนไปข้างหน้าเท่านั้น',
    note_required: 'กรุณากรอกข้อความบันทึก',
  },
  invoice_details: {
    title: 'รายละเอียดใบแจ้งหนี้',
    due: 'ครบกำหนด',
    amount: 'จำนวน',
    paid: 'ชำระแล้ว',
    balance: 'ยอดคงเหลือ',
  },
  case_summary: {
    title: 'สรุปเคส',
    days_overdue: 'วันที่เกินกำหนด',
    notice_sent: 'ส่งหนังสือแจ้ง',
    not_sent: '—',
  },
  legal_notice_toast: 'การสร้าง PDF หนังสือทางกฎหมายจะพร้อมใช้งานเร็วๆ นี้',
}
